import React from 'react'
import { BaseView } from '@/components/base'
import { useSendStore } from '@/store/useSendStore'

export const SendBackground: React.FC = () => {
  const selectedCurrency = useSendStore((state) => state.selectedCurrency)

  if (!selectedCurrency) {
    return null
  }

  const {
    sendRequestBGRefColor,
    sendRequestStartGradient,
    sendRequestEndGradient,
  } = selectedCurrency

  // Если цвет - массив (градиент)
  if (Array.isArray(sendRequestBGRefColor)) {
    const gradient = `linear-gradient(${getGradientDirection(sendRequestStartGradient, sendRequestEndGradient)}, ${sendRequestBGRefColor.join(', ')})`

    return (
      <BaseView
        className="fixed inset-0 z-0"
        style={{
          background: gradient,
        }}
      />
    )
  }

  // Если цвет - строка (сплошной цвет)
  return (
    <BaseView
      className="fixed inset-0 z-0"
      style={{
        backgroundColor: sendRequestBGRefColor,
      }}
    />
  )
}

// Функция для конвертации градиентных координат RN в CSS
const getGradientDirection = (
  start?: [number, number],
  end?: [number, number],
): string => {
  if (!start || !end) {
    return '135deg' // По умолчанию диагональный градиент
  }

  // RN использует координаты от 0 до 1
  // start = [x1, y1], end = [x2, y2]
  const [x1, y1] = start
  const [x2, y2] = end

  // Вычисляем угол градиента
  const deltaX = x2 - x1
  const deltaY = y2 - y1

  // Конвертируем в угол CSS (в градусах)
  let angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI)

  // CSS градиенты начинаются с верха (90 градусов в CSS = 0 градусов в математике)
  angle = angle + 90

  // Нормализуем угол от 0 до 360
  if (angle < 0) angle += 360
  if (angle >= 360) angle -= 360

  return `${angle}deg`
}
